import { Component, inject, DOCUMENT } from '@angular/core';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.css']
})
export class RedirectComponent {

  private doc = inject(DOCUMENT);

  constructor()
  {
    let url = this.doc.location.href;
    url = url.replace(/^.*\/\/[^\/]+/, '');
    this.doc.location.href = environment.apiURL + url
  }

}
